export default __webpack_public_path__ + "static/interaction1-1921bf0468a9deeeb7ef0f06f3edf9ae.mp4";